import { Injectable } from '@angular/core';

import { ApiService }           from '../api/api.service';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { VehicleModel }         from './models/vehicle';
import { VehiclesFiltersModel } from './typings/vehicles.filters';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService {
  public broadcastKey  = 'filterVehicles';
  public tableCacheKey = 'vehicles';

  constructor (
    private apiService: ApiService
  ) {}

  get ( params  : TableQueryParameters, filters : VehiclesFiltersModel ) : Promise<Array<VehicleModel>> {
    return this.apiService.stream('/filters', [
        filters.value || '*',
        'vehicles',
        params.offset,
        params.pageSize,
        params.field,
        params.direction,
        filters.archivedOnly
      ]);
  }

  getCount ( filters : VehiclesFiltersModel ) : Promise<number> {
    return this.apiService.get('/filters/count', [
        filters.value || '*',
        'vehicles',
        filters.archivedOnly
      ]);
  }
}
